export const EVENTKEY_MAP = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  HOME: 'Home',
  END: 'End',
  SPACE: ' ',
  TAB: 'Tab',
} as const;

export const REGEX = {
  // Supports Visa, Mastercard, American Express, Discover, JCB, Diners Club
  CREDIT_CARD_GLOBAL:
    /(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})/g,
  EMAIL_GLOBAL:
    /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g,
  JWT_GLOBAL: /\b([a-zA-Z0-9_-]{8,})\.[a-zA-Z0-9_-]{8,}\.[a-zA-Z0-9_-]{8,}\b/g,
  PHONE_NUMBER_GLOBAL:
    /[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}/g,
  ZIP_CODE_GLOBAL: /\d{5}(-\d{4})?/g,
  HEX_COLOR: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
  EDITOR_VARIABLE: /\{\{([^}]+)\}\}/g,
} as const;
